<template>
  <v-card v-if="isDebug" outlined tile color="grey lighten-2">
    <v-card-title v-text="title" />
    <v-card-text>
      <pre>{{object}}</pre>
    </v-card-text>
    <v-card-actions v-if="showPrintToConsole">
      <v-btn block color="secondary" @click="printInConsole">
        <v-fa-icon class="mr-1" small icon="terminal" />console
      </v-btn>
    </v-card-actions>
  </v-card>
</template>

<script>
export default {
  props: {
    title: String,
    object: [Object, Array],
    showPrintToConsole: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    isDebug: () => process.env.NODE_ENV == "development"
  },
  methods: {
    printInConsole() {
      console.log(this.object);
    }
  }
};
</script>